var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPointerClick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_3405_862)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3405_862",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3405_862",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3405_862",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAWlJREFUSA2lla1ORDEQRo/gARAIJBKJRCAQCB4BgUAiEEgeAsl7gIO3gAQSNoEEgQCCQCCQwLdpd7/t7eze7p2kudP5OZPbTluIZRN4it0Tj2J2JrOpIluYvwLcAsfT+FAT6K0oUrPNAM6BqxnL/IkDXa9m7QGvwFrVGxsF/khDelUEFVxFWiUs4Jt0CWh5WsWXxfUxJxsugDtAG1yKNvsT+AKOCmfO1zdLxybDO6DWrInAu2mokMtz0UHZJ6Z8veTXolw38zDVoa4Po1q2Q123kGGqQ10fRrVsh7puIe2q2nU1pTn0G9A8j/v/bjlsxec+/gFOEyxiKPaxcj6i+LFd18U+sA68LCigBBV5mEssnCO7j7bSISxCOlNfxo6zNBwAWtvatVHG5nlTASXdAGc5u8e3ucBGutz07SPNBQTVH1z3ofdohCpGe6Du0J4skqX+QNDt9KjnQxcVWrqAgHqMTiJysus96cgfms9QhiVhrcQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerClick);
export default __webpack_public_path__ + "static/media/pointer-click.0f7bf3dcd4ec4ef5aa134f81b011d7f8.svg";
export { ForwardRef as ReactComponent };